import { useQuery } from '@tanstack/react-query';
import type { PriorAuthCaseDetailsT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPriorAuthDetails } from '../api/priorAuthApi';
import { priorAuthKeys } from './keys';

export function priorAuthDetailsQueryDefinition(recordId: string) {
  return {
    queryKey: priorAuthKeys.details(recordId),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchPriorAuthDetails(recordId, signal),
    meta: {
      toast: {
        title: 'Could not load prior authorization',
        description: 'Prior authorization case details could not be fetched.',
      },
    },
  } as const;
}

export function usePriorAuthDetailsQuery(
  recordId: string | undefined,
  options?: {
    refetchInterval?:
      | number
      | false
      | ((query: {
          state: { data?: PriorAuthCaseDetailsT; dataUpdatedAt: number };
        }) => number | false);
  }
) {
  return useQuery({
    ...priorAuthDetailsQueryDefinition(recordId ?? ''),
    enabled: !!recordId,
    refetchInterval: options?.refetchInterval,
  });
}
